namespace GeniuzPOS.ReportMasterData {
    export interface Report_1504_NRow {
        Id?: string;
        Year?: string;
        PluCode?: string;
        PluDesc?: string;
        PluShortDesc?: string;
        CatCode?: string;
        CatName?: string;
        SubCat1Code?: string;
        SubCat1Name?: string;
        SubCat2Code?: string;
        SubCat2Name?: string;
        BrandCode?: string;
        BrandName?: string;
        StyleId?: string;
        StyleName?: string;
        ColorId?: string;
        ColorName?: string;
        SizeId?: string;
        SizeName?: string;
        TasteId?: string;
        TasteName?: string;
        MatTypeId?: string;
        MatTypeName?: string;
        SupplId?: string;
        SupplName?: string;
        TypeSum?: string;
        January?: number;
        February?: number;
        March?: number;
        April?: number;
        May?: number;
        June?: number;
        July?: number;
        August?: number;
        September?: number;
        October?: number;
        November?: number;
        December?: number;
    }

    export namespace Report_1504_NRow {
        export const idProperty = 'Id';
        export const nameProperty = 'Id';
        export const localTextPrefix = 'ReportMasterData.Report_1504_N';
        export const deletePermission = '1POSBASE:รายงาน:เปรียบเทียบ:ยอดขายรายเดือน:View';
        export const insertPermission = '1POSBASE:รายงาน:เปรียบเทียบ:ยอดขายรายเดือน:View';
        export const readPermission = '1POSBASE:รายงาน:เปรียบเทียบ:ยอดขายรายเดือน:View';
        export const updatePermission = '1POSBASE:รายงาน:เปรียบเทียบ:ยอดขายรายเดือน:View';

        export declare const enum Fields {
            Id = "Id",
            Year = "Year",
            PluCode = "PluCode",
            PluDesc = "PluDesc",
            PluShortDesc = "PluShortDesc",
            CatCode = "CatCode",
            CatName = "CatName",
            SubCat1Code = "SubCat1Code",
            SubCat1Name = "SubCat1Name",
            SubCat2Code = "SubCat2Code",
            SubCat2Name = "SubCat2Name",
            BrandCode = "BrandCode",
            BrandName = "BrandName",
            StyleId = "StyleId",
            StyleName = "StyleName",
            ColorId = "ColorId",
            ColorName = "ColorName",
            SizeId = "SizeId",
            SizeName = "SizeName",
            TasteId = "TasteId",
            TasteName = "TasteName",
            MatTypeId = "MatTypeId",
            MatTypeName = "MatTypeName",
            SupplId = "SupplId",
            SupplName = "SupplName",
            TypeSum = "TypeSum",
            January = "January",
            February = "February",
            March = "March",
            April = "April",
            May = "May",
            June = "June",
            July = "July",
            August = "August",
            September = "September",
            October = "October",
            November = "November",
            December = "December"
        }
    }
}
